<template>
  <div class="space-y-2">
    <div v-if="files.length === 0" class="text-center py-8 text-gray-500">
      <UIcon name="i-lucide-file-x" class="size-12 mx-auto mb-2 opacity-30" />
      <p class="text-sm">{{ emptyMessage }}</p>
    </div>
    
    <div v-else class="space-y-2">
      <div 
        v-for="file in files" 
        :key="file.id"
        class="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
      >
        <div class="flex items-center gap-3">
          <UIcon :name="getFileIcon(file.type)" class="size-5 text-gray-500" />
          <div>
            <p class="text-sm font-medium text-gray-900">{{ file.name }}</p>
            <p class="text-xs text-gray-500">{{ formatFileSize(file.size) }} • {{ formatDate(file.uploadedAt) }}</p>
          </div>
        </div>
        
        <div class="flex items-center gap-2">
          <UButton
            icon="i-lucide-download"
            color="gray"
            variant="ghost"
            size="sm"
            @click="$emit('download', file)"
          />
          <UButton
            icon="i-lucide-trash-2"
            color="gray"
            variant="ghost"
            size="sm"
            @click="$emit('delete', file)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  files: {
    type: Array,
    default: () => []
  },
  emptyMessage: {
    type: String,
    default: 'Keine Dateien vorhanden'
  }
})

defineEmits(['download', 'delete'])

const getFileIcon = (type) => {
  const iconMap = {
    'pdf': 'i-lucide-file-text',
    'doc': 'i-lucide-file-text',
    'docx': 'i-lucide-file-text',
    'xls': 'i-lucide-table',
    'xlsx': 'i-lucide-table',
    'csv': 'i-lucide-table',
    'jpg': 'i-lucide-image',
    'jpeg': 'i-lucide-image',
    'png': 'i-lucide-image',
    'gif': 'i-lucide-image',
    'zip': 'i-lucide-archive',
    'rar': 'i-lucide-archive',
    '7z': 'i-lucide-archive'
  }
  return iconMap[type?.toLowerCase()] || 'i-lucide-file'
}

const formatFileSize = (bytes) => {
  if (!bytes) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
}

const formatDate = (date) => {
  if (!date) return ''
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(date))
}
</script>